var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"select-product"}},[_c('product-gallery',{attrs:{"images":_vm.images,"sizes":_vm.sizes}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }